import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

const BeneficiosWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
`

const Beneficio = styled.div`
  flex: none;
  width: 50%;
  padding: 40px;
  box-sizing: border-box;
  color: #1d1d1b;

  ${breakpoint('tablet')`
    width: 25%;
  `}

  ul {
    list-style: none;
    text-align: center;
    margin: 5px 0 0;
    padding: 0;
  }

  li {
    font-size: 0.8em;
  }
`

const BeneficioIcono = styled.div`
  max-width: 100px;
  text-align: center;
  margin: 0 auto 10px;
`

const BeneficioTitular = styled.div`
  text-align: center;
`

const BeneficiosTitular = styled.div`
  text-align: center;
  font-size: 2em;
  max-width: 900px;
  width: 80%;
  margin: 40px auto 20px;
  color: #1d1d1b;
`

const ReglamentoContainer = styled.div`
  background: ${props => props.theme.colors.grisDeFondo};
  text-align: center;
  padding: 40px 0;

  & > div {
    max-width: 980px;
    margin: 0 auto;
  }

  a {
    color: #0d62a7;
    text-decoration: none;
    display: inline-block;
    margin: 0 10px;
  }
`

export {
  BeneficiosWrapper,
  Beneficio,
  BeneficioIcono,
  BeneficioTitular,
  BeneficiosTitular,
  ReglamentoContainer,
}
